import api from '../../api';

const state = {
  drones: [],
  selected: null,
  historyByDrone: {},
  djiStatus: null,
  events: [],
  loading: false,
  error: null,
};

const getters = {
  drones: (state) => state.drones,
  selected: (state) => state.selected,
  historyForDrone: (state) => (id) => state.historyByDrone[String(id)] || [],
  onlineCount: (state) => state.drones.filter((d) => ['online', 'streaming', 'warning'].includes(d.status)).length,
};

const mutations = {
  setDrones(state, drones) { state.drones = drones || []; },
  setSelected(state, drone) { state.selected = drone; },
  setHistory(state, { droneId, history }) {
    state.historyByDrone = {
      ...state.historyByDrone,
      [String(droneId)]: history || [],
    };
  },
  setDjiStatus(state, status) { state.djiStatus = status; },
  setEvents(state, events) { state.events = events || []; },
  setLoading(state, value) { state.loading = value; },
  setError(state, value) { state.error = value; },
  upsertDrone(state, drone) {
    if (!drone) return;
    const id = String(drone._id || drone.id);
    const idx = state.drones.findIndex((item) => String(item._id || item.id) === id);
    if (idx >= 0) state.drones.splice(idx, 1, { ...state.drones[idx], ...drone });
    else state.drones.push(drone);
    if (state.selected && String(state.selected._id) === id) state.selected = { ...state.selected, ...drone };
  },
  appendTelemetry(state, { droneId, telemetry }) {
    if (!telemetry || !droneId) return;
    const key = String(droneId);
    const history = [...(state.historyByDrone[key] || [])];
    const last = history[history.length - 1];
    if (last && String(last.timestamp) === String(telemetry.timestamp)) return;
    history.push(telemetry);
    if (history.length > 500) history.shift();
    state.historyByDrone = {
      ...state.historyByDrone,
      [key]: history,
    };
  },
};

const actions = {
  async fetchDrones({ commit }) {
    commit('setLoading', true);
    try {
      const { data } = await api.get('/api/drones');
      commit('setDrones', data.drones || []);
      commit('setError', null);
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Не удалось загрузить дроны');
    } finally { commit('setLoading', false); }
  },
  async fetchDrone({ commit }, id) {
    const { data } = await api.get(`/api/drones/${id}`);
    commit('setSelected', data.drone);
    return data.drone;
  },
  async fetchHistory({ commit }, id) {
    const { data } = await api.get(`/api/drones/${id}/telemetry/history?limit=300`);
    commit('setHistory', { droneId: id, history: data.events || [] });
    return data.events || [];
  },
  async sendFakeTelemetry({ commit }, id) {
    const { data } = await api.post(`/api/drones/${id}/telemetry/fake`);
    commit('upsertDrone', data.drone);
    commit('appendTelemetry', { droneId: id, telemetry: data.telemetry });
    return data;
  },
  async createDrone({ dispatch }, payload) {
    await api.post('/api/drones', payload);
    await dispatch('fetchDrones');
  },
  async updateDrone({ dispatch }, { id, patch }) {
    await api.patch(`/api/drones/${id}`, patch);
    await dispatch('fetchDrones');
  },
  async fetchEvents({ commit }, id) {
    const { data } = await api.get(`/api/drones/${id}/events?limit=100`);
    commit('setEvents', data.events || []);
    return data.events || [];
  },
  async fetchDjiStatus({ commit }) {
    const { data } = await api.get('/api/system/dji-status');
    commit('setDjiStatus', data);
    return data;
  },
};

export default { namespaced: true, state, getters, mutations, actions };
